module.exports = require(122).EventEmitter;
